import { Col, Divider, Modal, Row, Slider, Space, Tag, InputNumber, Card, Flex, Button } from "antd";
import { Form, Formik } from "formik";
import { useEffect, useState } from "react";

import { DatePicker, Input, RadioGroup, Select } from "components/form";
import styles from "../styles/CompanyBranchFilter.module.css";
import useStatusFlagOption from "components/elements/Select/StatusDropdown";
import { useTranslation } from "react-i18next";

const CompanyBranchFilter = ({
  initialValues = {},
  shiftOptions = [],
  titleNameOptions = [],
  employeeTypeOptions = [],
  modifiedPositionOptions = [],
  organizationUnderOptions = [],
  welfareList = [],
  provinceOptionsTh = [],
  provinceOptionsEn = [],
  welfareOption = [],
  welfareTypeOptions = [],
  dataFlag = null,
  roleOption = [],
  shiftDropDown = [],
  onCancel = () => { },
  onSubmit = () => { },
  onSearch = () => { },
}) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(null);
  const [optionType, setOptionType] = useState(null);
  const flagPage = null;
  const { modifiedStatus = [] } = useStatusFlagOption()
  const statusOption = [
    {
      value: "All",
      name: "All"
    },
    {
      value: "Active",
      name: "Active"
    },
    {
      value: "Inactive",
      name: "Inactive"
    },
    {
      value: "Delete",
      name: "Delete"
    }
  ]
  console.log("roleOptionroleOption", roleOption);
  return (

    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        onSubmit({
          ...values,
        });
      }}

    // validationSchema={schema}
    >
      {({ resetForm, values = {}, setFieldValue = () => { }, setTouched = () => { } }) => {
        return (

          <Form>
            {dataFlag == "branch" && (
              <Card>
                <Row gutter={[24, 16]}>
                  <Col span={12}>
                    <Input
                      name="branchName"
                      label={t('company_profile.label.branch_name')}
                      placeholder={t('company_profile.label.branch_name')}
                      size="large"
                    />
                  </Col>
                  {i18n.language === "en" && (
                    <Col span={12}>
                      <Select
                        name="provinceCode"
                        label={t('translation.province')}
                        placeholder={t('please-select-1')}
                        size="large"
                        options={provinceOptionsEn}
                      />
                    </Col>
                  )}
                  {i18n.language === "th" && (
                    <Col span={12}>
                      <Select
                        name="provinceCode"
                        label={t('translation.province')}
                        placeholder={t('please-select-1')}
                        size="large"
                        options={provinceOptionsTh}
                      />
                    </Col>
                  )}
                  <Col span={12}>
                    <Select
                      name="status"
                      label={t('translation.status')}
                      placeholder={t('please-select-1')}
                      size="large"
                      options={modifiedStatus}
                    />
                  </Col>
                </Row>
                <Flex style={{ marginTop: "3vh", gap: "12px" }} justify="end" className={styles.filterbtn}>

                  <Button type="default" onClick={resetForm} style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}>
                    {t("common.cancel").toUpperCase()}
                  </Button>
                  <Button type="primary" htmlType="submit" style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}>
                    {t("creatTamplete.Search").toUpperCase()}
                  </Button>
                </Flex>

              </Card>
            )}
          </Form>
        );
      }}
    </Formik>
  );
};

export default CompanyBranchFilter;
